"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.promise = void 0;
var React = __importStar(require("react"));
var widget_1 = require("../basics/widget");
var options_1 = require("../basics/options");
/**
 * Don't use directly, use the [[promise]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it has not state.
 */
var PromiseComponent = /** @class */ (function (_super) {
    __extends(PromiseComponent, _super);
    function PromiseComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.mounted = true;
        _this.state = {};
        _this.mounted = true;
        return _this;
    }
    PromiseComponent.prototype.run_promise = function (i) {
        var _this = this;
        if (this.status == "running")
            return;
        this.status = "running";
        this.props.actual_promise(i)
            .then(function (res) {
            _this.status = "done";
            if (_this.mounted)
                _this.props.on_done(res);
            else
                console.warn("Skipping promise on_done on unmounted component");
        }, function (reason) {
            _this.status = "failed";
            if (_this.props.options && _this.props.options.on_fail) {
                if (_this.mounted)
                    _this.props.on_done(_this.props.options.on_fail(reason));
                else
                    console.warn("Skipping promise on_done on unmounted component");
            }
        });
    };
    PromiseComponent.prototype.componentDidUpdate = function (newProps) {
        if ((0, options_1.option)("call_promise_when_receive_new_props", this.props.options))
            this.run_promise(newProps.input);
    };
    PromiseComponent.prototype.componentDidMount = function () {
        this.mounted = true;
        this.run_promise(this.props.input);
    };
    PromiseComponent.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    PromiseComponent.prototype.render = function () {
        return React.createElement("div", { key: "".concat((0, options_1.option)("key", this.props.options), "-inner"), className: this.status });
    };
    return PromiseComponent;
}(React.Component));
/**
 * An adapter from a parametric JS-promise into a widget
 *
 * @typeparam i the input parameter of the parametric promise.
 *
 * When `GET`ting stuff, `i` usually is `Unit` or `void`.
 * @typeparam o the output type of the parametric promise.
 *
 * When `POST`ing stuff, `o` usually is `Unit` or `void`.
 *
 */
var promise = function (p, options) {
    return function (input) { return (0, widget_1.fromJSX)(function (on_done) {
        return React.createElement(PromiseComponent, { on_done: on_done, input: input, 
            /* makes call_promise_when_receive_new_props to default to false */
            options: options.call_promise_when_receive_new_props == undefined ? __assign(__assign({}, options), { call_promise_when_receive_new_props: false }) : options,
            actual_promise: p,
            key: options.key });
    }); };
};
exports.promise = promise;
